import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Tooltip
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { getServiceCity } from "redux/actions/UserServiceCity";
import {
  fetchCompanyList,
  fetchParentCompanys,
} from "redux/actions/companyAction";
import CommonFilter from "components/commonFilter/CommonFilter";
import CommonDateRangePicker from "components/commonDateRangePicker/CommonDateRangePicker";
import { optionsList, truncateComment } from "utils/utils";
import { reportHeaderForm ,misHeaderForm} from "./ReportsHeaderData";
import { selectOptionStyle } from "components/commonTable/CommonTableStyle";
import "./ReportHeader.scss";

const ReportsHeader = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getServiceCity());
    dispatch(fetchParentCompanys());
    dispatch(fetchCompanyList({ pageSize: 100, companyType :'SubCompany', type:'report' }));
  }, []);

  const cityList = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );

  const parentCompanyList = useSelector(
    (state) => state?.parentCompanyList?.parentCompanyList?.body
  );

  const companyList = useSelector(
    (state) => state?.userCompany?.companyList?.body
  );

  const cityOption = optionsList(cityList, "cityOption");
  const parentCompanyListOption = optionsList(
    parentCompanyList,
    "parentCompanyList"
  );
  const allCompanyListOption = optionsList(companyList, "parentCompanyList");

  const formOptions = props?.misReport
    ? misHeaderForm(cityOption, allCompanyListOption)
    : reportHeaderForm(cityOption, parentCompanyListOption, allCompanyListOption);

  return (
    <Grid container justifyContent={"space-between"} className="pb20">
      <Grid item xs={12} sm={6}>
        <Box className="flex">
          {formOptions?.map((filterOptions, index) => (
            <Box className="pr20 filterOptions" key={index}>
              <FormControl className={"customHeaderSelect"}>
                <Select
                  name={filterOptions?.name}
                  IconComponent={(params) => (
                    <ExpandMoreRoundedIcon className="mr10" {...params} />
                  )}
                  disabled={filterOptions?.name === "allCity" && props?.locationData}
                  onChange={(e) => {
                    if (filterOptions?.name === "allCity") {
                      props?.handleCityChange(e);
                    } else if (filterOptions?.name === "parentCompany") {
                      props?.handleParentCompanyChange(e);
                    } else if (filterOptions?.name === "allCompanies") {
                      props?.handleAllCompanyChange(e);
                    }
                  }}
                  value={
                    filterOptions?.name === "allCity"
                      ? props?.selectedCity || props?.locationData
                      : filterOptions?.name === "parentCompany"
                      ? props?.selectedParentCompany
                      : props?.selectedAllCompany
                  }
                  displayEmpty
                  MenuProps={{
                    PaperProps: {
                      style: selectOptionStyle
                    },
                  }}
                >
                  <InputLabel className="colorGrey ml16">
                    <Typography className="colorGrey" variant="body2">
                      {filterOptions?.placeHolder?.length > 15
                        ? truncateComment(filterOptions?.placeHolder, 15)
                        : filterOptions?.placeHolder}
                    </Typography>
                  </InputLabel>
                  <MenuItem
                      key={index}
                      value={""}
                    > {filterOptions?.placeHolder?.length > 15 ?
                      <Tooltip title={filterOptions?.placeHolder}>{truncateComment(filterOptions?.placeHolder, 15)}</Tooltip> 
                      : filterOptions?.placeHolder }
                    </MenuItem>
                  {filterOptions?.menuList?.map((option, index) => (
                    <MenuItem
                      key={index}
                      value={option.value || ""}
                    >
                      {option?.label?.length > 15
                        ? <Tooltip title={option.label}>{truncateComment(option.label, 15)}</Tooltip> 
                        : option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ))}
        </Box>
      </Grid>
      <Grid container item xs={12} sm={5} justifyContent={"flex-end"}>
        <CommonDateRangePicker
          onSelectDateRange={props?.onSelectDateRange}
          dateFrom={props?.dateFrom}
          dateTo={props?.dateTo}
        />
        <CommonFilter
        report={props?.report}
          defaultStatus={props?.defaultStatus}
          filterdata={props?.filterData}
          onFilterChange={props?.onFilterChange}
          onRestFilter={props?.onRestFilter}
          defaultLocation={props?.defaultLocation}
        />
      </Grid>
    </Grid>
  );
};

export default ReportsHeader;
